import { useRef, useState } from 'react';

type UseFileDownloadArgs = {
  downloadFile?: (item: any, preferredURI?: string) => Promise<string | null>; // eslint-disable-line @typescript-eslint/no-explicit-any
  item: any; // eslint-disable-line @typescript-eslint/no-explicit-any
  loadedURI?: string;
};

/** The download-click state machine: pending flag, blocked-tab link, and re-entrancy guard. */
export function useFileDownload({ downloadFile, item, loadedURI }: UseFileDownloadArgs) {
  const [downloadPending, setDownloadPending] = useState(false);
  const [blockedLink, setBlockedLink] = useState<string | null>(null);
  // *: What a double click races against: state has not re-rendered yet when the
  // *: second click lands.
  const downloadInFlight = useRef(false);

  const handleDownload = () => {
    if (!downloadFile || downloadInFlight.current) return;
    downloadInFlight.current = true;
    setDownloadPending(true);
    setBlockedLink(null);
    // *: Called straight from the click or key handler: downloadFile opens its tab
    // *: before any await, while the browser still counts the user gesture.
    downloadFile(item, loadedURI)
      .then(setBlockedLink)
      .catch((error) => {
        console.error('🚀 FileContainer download failed: ', error);
      })
      .finally(() => {
        downloadInFlight.current = false;
        setDownloadPending(false);
      });
  };

  const handleDownloadKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    // *: Space would otherwise scroll the page.
    event.preventDefault();
    handleDownload();
  };

  return { downloadPending, blockedLink, handleDownload, handleDownloadKeyDown };
}
